module.exports = __webpack_public_path__ + "static/media/portfolio2.5e2dae80.png";